import { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import { Card, CardBody, Col, Container, Row, Table } from "reactstrap";
import { Image } from "../../../../../AbstractElements";
import { dynamicImage } from "../../../../../Utils";
import { InvoiceButtons } from "../Common/InvoiceButtons";
import InvoiceContent from "./InvoiceContent";
import InvoiceHeader from "./InvoiceHeader";
import InvoiceOrder from "./InvoiceOrder";
import InvoiceSign from "./InvoiceSign";

const Invoice1Container = () => {
  const contentRef = useRef<HTMLDivElement | null>(null);
  const handlePrint = useReactToPrint({ contentRef });

  return (
    <>
      <Container>
        <Row>
          <Col sm="12">
            <div ref={contentRef}>
              <Card className="invoice-1">
                <CardBody>
                  <Table className="table-wrapper" borderless>
                    <tbody>
                      <tr>
                        <InvoiceHeader />
                      </tr>
                      <tr>
                        <td className="bg-img-cover">
                          <Image className="banner-image w-100" src={dynamicImage(`email-template/invoice-1/1.png`)} alt="background" />
                        </td>
                      </tr>
                      <tr>
                        <InvoiceContent />
                      </tr>
                      <tr>
                        <InvoiceOrder />
                      </tr>
                    </tbody>
                    <tbody>
                      <InvoiceSign />
                    </tbody>
                  </Table>
                </CardBody>
              </Card>
            </div>
          </Col>
        </Row>
      </Container>
      <InvoiceButtons handlePrint={handlePrint} />
    </>
  );
};

export default Invoice1Container;
